<template>
  <div
    v-if="aiItemList.length"
    :class="['automatedaicss-wrapper', { 'fill-height': shouldFillHeight }]"
  >
    <div
      class="automatedaicss-toggle"
      @click="onToggleActivate"
      :class="{ active: localIsActive }"
    >
      <span>{{ title }}</span>
      <img
        :class="{ up: localIsActive }"
        class="automatedaicss-toggle-icon"
        src="@/assets/img/chevron-down.svg"
      />
    </div>
    <b-collapse
      :visible="localIsActive"
      @input="handleCollapseInput"
      :class="[
        'automatedaicss-toggle-element',
        'fancy-scroll',
        { 'fill-height': shouldFillHeight },
      ]"
    >
      <b-card
        v-for="(item, index) of aiItemList"
        :key="`${codeType}-${item.entryId}-${index}`"
        :id="`ai-${codeType}-${index}`"
      >
        <div class="menu-wrapper">
          <div
            class="action-icon-wrap"
            @click="$emit('onEdit', item.entryId, `ai-${codeType}-${index}`)"
          >
            <img
              :src="require('@/assets/img/common/rename.svg')"
              alt="edit"
              :title="aiCodeTypes?.[codeType]?.tooltip || 'löschen'"
            />
          </div>
          <div
            class="action-icon-wrap"
            @click="$emit('onRemove', codeType, item.entryId)"
          >
            <img
              src="@/assets/img/delete-icon-ai-styles.svg"
              alt="remove"
              :title="aiCodeTypes?.[codeType]?.tooltip || 'löschen'"
              v-b-tooltip.hover.bottom
            />
          </div>
          <div class="action-icon-wrap" @click="toggleValueView(index)">
            <img
              class="code-tag"
              alt="code"
              :src="require('@/assets/img/code-tag.svg')"
            />
          </div>
        </div>
        <textarea
          v-if="codeVisibleIndex === index"
          disabled
          @keydown.prevent
          :value="getValue(item)"
          class="automatedaicss-textarea"
        ></textarea>
        <span
          class="prompt-span"
          v-else
          v-html="getformatedExplanation(item)"
        ></span>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
import {
  getInputVariableList,
  getElementSuggetionById,
} from '@/utils/helpers/FormBuilderHelper.js';
export default {
  name: 'FormAICodeAccordion',

  data() {
    return {
      localIsActive: false,
      prevIsActive: null,
      codeVisibleIndex: null,

      // form accourdion types
      aiCodeTypes: {
        style: { tooltip: 'CSS löschen' },
        logic: { tooltip: 'Logik löschen' },
      },
    };
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    codeType: {
      type: String,
      default: '',
    },
    elements: {
      type: Array,
      default: () => [],
    },
    aiItemList: {
      type: Array,
      default: () => [],
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    shouldFillHeight: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onToggleActivate() {
      const nextState = !this.localIsActive;
      this.$emit('toggle', nextState);
      this.handleCollapseInput(nextState);
    },

    toggleValueView(index) {
      this.codeVisibleIndex = this.codeVisibleIndex === index ? null : index;
    },
    getValue(item) {
      return this.codeType === 'style' ? item?.styles : item?.code;
    },
    getformatedExplanation(item) {
      return (item?.prompt || '').replace(/\{(.*?)\}/g, (match, varName) => {
        const found = this.getInputVariables.some(
          (v) => v?.name === varName.trim()
        );
        if (found) {
          return `<span class="chip">${varName}</span>`;
        }
        const suggestId = getElementSuggetionById(
          varName,
          this.getInputVariables
        );

        if (suggestId) {
          return `<span class="chip">${suggestId.displayName}</span>`;
        } else {
          return `{${varName}}`;
        }
      });
    },
    handleCollapseInput(isVisible) {
      this.localIsActive = isVisible;
      if (!isVisible) {
        this.codeVisibleIndex = null;
      }
    },
    syncActiveState(nextValue) {
      const normalized = !!nextValue;
      if (this.localIsActive === normalized) return;
      this.handleCollapseInput(normalized);
    },
  },
  computed: {
    getInputVariables() {
      return getInputVariableList(this.elements);
    },
  },
  mounted() {
    const initialState = !!this.isActive;
    this.prevIsActive = initialState;
    this.syncActiveState(initialState);
  },
  updated() {
    const currentState = !!this.isActive;
    if (currentState !== this.prevIsActive) {
      this.syncActiveState(currentState);
      this.prevIsActive = currentState;
    }
  },
};
</script>

<style scoped>
.automatedaicss-wrapper {
  display: flex;
  flex-direction: column;
}
.automatedaicss-wrapper.fill-height {
  min-height: 0;
}
.automatedaicss-toggle {
  width: 100%;
  height: 60px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px,
    rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
  cursor: pointer;
  /* transition: all 400ms ease-in-out; */
}
.automatedaicss-toggle.active {
  box-shadow: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e9dfdf;
  border-bottom: none;
}

.automatedaicss-toggle-element {
  transition: none;
}
.automatedaicss-toggle-element.collapse {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  display: flex;
  flex-flow: column;
  border: 1px solid #e9dfdf;
  overflow: auto;
  padding: 0 10px;
}
.automatedaicss-toggle-element.fill-height {
  max-height: none;
}
.automatedaicss-toggle-element.fill-height.collapsing {
  flex: 1;
  height: auto !important;
}
.automatedaicss-wrapper.fill-height
  .automatedaicss-toggle-element.fill-height.collapse {
  overflow: auto;
  display: block;
  padding: 0;
}
.automatedaicss-toggle-element.collapse .card {
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #e9dfdf;
}
.automatedaicss-toggle-element.collapse .card:last-child {
  border: none;
  border-radius: 0;
}
.automatedaicss-toggle-element.collapse .prompt-span {
  white-space: pre-line;
}

.automatedaicss-toggle-icon {
  font-size: 36px;
  transition: transform 0.5s ease-in-out;
}
.automatedaicss-toggle-icon {
  width: 16px;
  transition: transform 0.5s ease-in-out;
}
.automatedaicss-toggle-icon.up {
  transform: rotate(180deg);
}
.prevent-pointer-event {
  pointer-events: none;
}

.btn.btn-senden {
  white-space: normal;
}

.automatedaicss-wrapper textarea {
  resize: none;
  background: #fff;
  border: none;
  padding: 5px 0px 0px 5px;
  margin: 0;
  color: #464d5d;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: scroll;
}
.automatedaicss-toggle-element .menu-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  gap: 5px;
  margin-bottom: 10px;
}
.automatedaicss-toggle-element .menu-wrapper .action-icon-wrap {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  cursor: pointer;
}
.automatedaicss-toggle-element .menu-wrapper .action-icon-wrap:has(.code-tag) {
  width: 25px;
  height: 25px;
}
.automatedaicss-toggle-element .action-icon-wrap img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: brightness(0);
}
.automatedaicss-wrapper ::v-deep .chip {
  background: #343331;
  color: white;
  border-radius: 4px;
  padding: 2px 4px;
  display: inline-block;
  margin-right: 4px;
  margin-bottom: 2px;
}
.fancy-scroll::-webkit-scrollbar {
  width: 4px !important;
}

.fancy-scroll::-webkit-scrollbar-thumb {
  background-color: black;
}
</style>
